<template>
  <PlotlyLineChart
    v-if="currentTopoProfile"
    class="fill-height"
    :responsive="false"
    :data="soilCompositionPlotData"
    :showAnimate="false"
    :trace-index="[0]"
    :annotations="[...annotations, currentItemAnnotation]"
    :refPlot="refPlot"
    :ref="refPlot"
    :hoverIds="[]"
    :clickEvent="true"
    @action="clickPoint"
  ></PlotlyLineChart>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PlotlyLineChart from '@/components/plotly-chart/PlotlyLineChart.vue'
import AnnotationMixin from '@/mixins/AnnotationMixin.vue'

export default {
  name: 'StatesLineChart',
  components: { PlotlyLineChart },
  mixins: [AnnotationMixin],
  data: () => ({
    indexActivePoint: null
  }),
  computed: {
    ...mapState('topoProfile', {
      currentTopoProfile: (state) => state.currentItem
    }),
    ...mapState('statePoints', {
      statePointColor: (state) => state.color
    }),
    ...mapGetters('statePoints', {
      statePointPlot: 'getPlotData'
    }),
    ...mapGetters('topoProfilePoint', {
      topoPlotData: 'getPlotData'
    }),
    ...mapGetters('soilLayer', {
      soilLayerPlotData: 'getPlotData'
    }),
    soilCompositionPlotData() {
      let plot = [...this.soilLayerPlotData(), ...this.topoPlotData(), ...this.statePointPlot()]
      return plot
    },
    refPlot() {
      return `state-${this.currentTopoProfile.id}`
    },
    currentItemAnnotation() {
      return this.indexActivePoint !== null
        ? {
            x: this.indexActivePoint[0],
            y: this.indexActivePoint[1],
            arrowhead: 6,
            ax: 36,
            ay: -24,
            bgcolor: 'rgba(255, 255, 255, 0.9)',
            arrowcolor: this.statePointColor,
            bordercolor: this.statePointColor,
            borderwidth: 1,
            borderpad: 3,
            text: `<b>(${this.indexActivePoint[0]}, ${this.indexActivePoint[1]})</b>`,
            font: {
              size: 14,
              color: 'black'
            }
          }
        : null
    }
  },
  methods: {
    clickPoint(event) {
      this.indexActivePoint = [event.points[0].x, event.points[0].y]
      this.$emit('clickPoint', {
        pointIndex: event.points[0].pointIndex
      })
    },
    setActiveItem({ index }) {
      this.indexActivePoint = [this.statePointPlot()[0].x[index], this.statePointPlot()[0].y[index]]
      this.$emit('clickPoint', {
        pointIndex: index
      })
    },
    deleteActiveItem() {
      this.indexActivePoint = null
    }
  }
}
</script>
